const PNP_REFRESH_V1 = 'GROW-2792';
const DESC_MESSAGE = '[Type: String][Vis.: high] - form features tooltips - A string in pricing experiment GROW-2729';
const TEAM_COLLABORATION_HEADING = 'Team Collaboration';
const TEAM_COLLABORATION_TOOLTIP = `Build, edit, analyze and comment on surveys together, plus access a shared asset library for on-brand surveys. As admin, you can invite more people to join the team and manage existing accounts. Available for Advantage and Premier members with 3+ users on an annual account. Advanced collaboration features available for enterprise customers.`;
const QUESTION_TYPES_HEADING = 'Questions types';
const QUESTION_TYPES_TOOLTIP = `Pick from 25+ question types to ensure you get exactly the information you need. With the forms plan you'll have what you need to collect contact information, online orders, and more.`;

const experimentTooltipCopy = {
  grow_2792_single_user_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.SingleUserTooltipHeading',
    defaultMessage: TEAM_COLLABORATION_HEADING,
    desc: {
      id: 'Pricing.experimentTooltipCopy.SingleUserTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_single_user_tooltip: {
    id: 'Pricing.experimentTooltipCopy.SingleUserTooltip',
    defaultMessage: TEAM_COLLABORATION_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.SingleUserTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_team_collaboration_user_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.TeamCollaborationUserTooltipHeading',
    defaultMessage: TEAM_COLLABORATION_HEADING,
    desc: {
      id: 'Pricing.experimentTooltipCopy.TeamCollaborationUserTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_team_collaboration_user_tooltip: {
    id: 'Pricing.experimentTooltipCopy.TeamCollaborationUserTooltip',
    defaultMessage: TEAM_COLLABORATION_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.TeamCollaborationUserTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_advanced_team_collaboration_user_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.AdvancedTeamCollaborationUserTooltipHeading',
    defaultMessage: TEAM_COLLABORATION_HEADING,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AdvancedTeamCollaborationUserTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_advanced_team_collaboration_user_tooltip: {
    id: 'Pricing.experimentTooltipCopy.AdvancedTeamCollaborationUserTooltip',
    defaultMessage: TEAM_COLLABORATION_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AdvancedTeamCollaborationUserTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_survey_create_limit_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.SurveyCreateLimitTooltipHeading',
    defaultMessage: 'Number of surveys and forms',
    desc: {
      id: 'Pricing.experimentTooltipCopy.SurveyCreateLimitTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_survey_create_limit_tooltip: {
    id: 'Pricing.experimentTooltipCopy.SurveyCreateLimitTooltip',
    defaultMessage: 'You can create and send as many surveys, polls, forms, and quizzes as you need with any plan.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.SurveyCreateLimitTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_unlimited_questions_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.UnlimitedQuestionsTooltipHeading',
    defaultMessage: 'Questions per survey/fields per form',
    desc: {
      id: 'Pricing.experimentTooltipCopy.UnlimitedQuestionsTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_unlimited_questions_tooltip: {
    id: 'Pricing.experimentTooltipCopy.UnlimitedQuestionsTooltip',
    defaultMessage: 'You can add unlimited questions to a survey and unlimited fields to a form with any paid plan.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.UnlimitedQuestionsTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_forms_question_types_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.FormsQuestionTypesTooltipHeading',
    defaultMessage: QUESTION_TYPES_HEADING,
    desc: {
      id: 'Pricing.experimentTooltipCopy.FormsQuestionTypesTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_forms_question_types_tooltip: {
    id: 'Pricing.experimentTooltipCopy.FormsQuestionTypesTooltip',
    defaultMessage: QUESTION_TYPES_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.FormsQuestionTypesTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_all_question_types_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.AllQuestionTypesTooltipHeading',
    defaultMessage: QUESTION_TYPES_HEADING,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AllQuestionTypesTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_all_question_types_tooltip: {
    id: 'Pricing.experimentTooltipCopy.AllQuestionTypesTooltip',
    defaultMessage: QUESTION_TYPES_TOOLTIP,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AllQuestionTypesTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_analyze_export_enabled_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.AnalyzeExportEnabledTooltipHeading',
    defaultMessage: 'Data exports',
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalyzeExportEnabledTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_analyze_export_enabled_tooltip: {
    id: 'Pricing.experimentTooltipCopy.AnalyzeExportEnabledTooltip',
    defaultMessage: `Create and print custom charts and reports quickly and easily. You'll be able to download survey results in several file formats, including as CSV, PDF, PPT, or XLS files. Export for SPSS for Premier and Enterprise members.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.AnalyzeExportEnabledTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_website_embed_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.WebsiteEmbedTooltipHeading',
    defaultMessage: 'Website embed',
    desc: {
      id: 'Pricing.experimentTooltipCopy.WebsiteEmbedTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_website_embed_tooltip: {
    id: 'Pricing.experimentTooltipCopy.WebsiteEmbedTooltip',
    defaultMessage: 'Seamlessly embed a form or survey on your website, or present them in a pop-up message.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.WebsiteEmbedTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_zapier_integrations_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.ZapierIntegrationsTooltipHeading',
    defaultMessage: '5000+ integrations with Zapier',
    desc: {
      id: 'Pricing.experimentTooltipCopy.ZapierIntegrationsTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_zapier_integrations_tooltip: {
    id: 'Pricing.experimentTooltipCopy.ZapierIntegrationsTooltip',
    defaultMessage:
      'Zapier lets you connect SurveyMonkey with thousands of the most popular apps, so you can automate your workflow and have more time for what matters most—no code required.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.ZapierIntegrationsTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_skip_logic_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.SkipLogicTooltipHeading',
    defaultMessage: 'Customized survey experience',
    desc: {
      id: 'Pricing.experimentTooltipCopy.SkipLogicTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_skip_logic_tooltip: {
    id: 'Pricing.experimentTooltipCopy.DataExportsTooltip',
    defaultMessage: `Get more ways to personalize each respondent's experience while taking your survey. Use skip logic to create custom paths through a survey based on each respondent's answers. With question & answer piping, you can insert answer text from a question into another question on a later page in the survey.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.DataExportsTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_create_custom_theme_enabled_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.CreateCustomThemeEnabledTooltipHeading',
    defaultMessage: 'Custom themes, colors & more',
    desc: {
      id: 'Pricing.experimentTooltipCopy.CreateCustomThemeEnabledTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_create_custom_theme_enabled_tooltip: {
    id: 'Pricing.experimentTooltipCopy.CreateCustomThemeEnabledTooltip',
    defaultMessage:
      'Create custom themes to change the look and feel of your survey. You can edit the colors of different survey elements and choose from several web fonts for your survey.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.CreateCustomThemeEnabledTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_text_analysis_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.TextAnalysisTooltipHeading',
    defaultMessage: 'Advanced survey analysis',
    desc: {
      id: 'Pricing.experimentTooltipCopy.TextAnalysisTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_text_analysis_tooltip: {
    id: 'Pricing.experimentTooltipCopy.TextAnalysisTooltip',
    defaultMessage:
      'Get more context for your data. See if there are statistically significant differences between response groups. And use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.TextAnalysisTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_a_b_testing_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.ABTestingTooltipHeading',
    defaultMessage: 'A/B test question type & statistical significance analysis',
    desc: {
      id: 'Pricing.experimentTooltipCopy.ABTestingTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_a_b_testing_tooltip: {
    id: 'Pricing.experimentTooltipCopy.ABTestingTooltip',
    defaultMessage:
      'Conduct A/B tests and test for answer bias by randomly segmenting respondents to see different images or text. Use statistical significance analysis to see if there are statistically significant differences between response groups.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.ABTestingTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_recurring_surveys_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.RecurringFormsSurveysTooltip',
    defaultMessage: 'Recurring forms & surveys',
    desc: {
      id: 'Pricing.experimentTooltipCopy.RecurringFormsSurveysTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_recurring_surveys_tooltip: {
    id: 'Pricing.experimentTooltipCopy.RecurringFormsSurveysTooltipDescription',
    defaultMessage: `Recurring forms & surveys make it easy to collect new results for the same forms & surveys on a weekly, monthly, or quarterly basis. We'll email you new survey links when they're ready, so all you need to do is copy each new link and send it to respondents. Filter your results by each occurrence to see how people responded differently over time.`,
    desc: {
      id: 'Pricing.experimentTooltipCopy.RecurringFormsSurveysTooltipDescription',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_customer_success_manager_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.CustomerSuccessManagerTooltip',
    defaultMessage: 'Customer Success Manager',
    desc: {
      id: 'Pricing.experimentTooltipCopy.CustomerSuccessManagerTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_customer_success_manager_tooltip: {
    id: 'Pricing.experimentTooltipCopy.CustomerSuccessManagerTooltipDescription',
    defaultMessage:
      'Get a dedicated customer success manager to help you with onboarding, training users as well as implementing best practices to ensure optimal use of the SurveyMonkey platform across your organization.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.CustomerSuccessManagerTooltipDescription',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_advanced_collaboration_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.AdvancedCollaborationTooltip',
    defaultMessage: 'Contributor seats',
    desc: {
      id: 'Pricing.experimentTooltipCopy.AdvancedCollaborationTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_advanced_collaboration_tooltip: {
    id: 'Pricing.experimentTooltipCopy.AdvancedCollaborationTooltipDescription',
    defaultMessage:
      'While purchasing a team plan, you can add Contributor seats as a cost-effective way to include more stakeholders to analyze survey results. Contributors can use SurveyMonkey analysis features but cannot create or send surveys. Full Users on your team can share surveys with Contributors.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.AdvancedCollaborationTooltipDescription',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_database_response_view_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.DatabaseResponseViewTooltip',
    defaultMessage: 'Database response view',
    desc: {
      id: 'Pricing.experimentTooltipCopy.DatabaseResponseViewTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_database_response_view_tooltip: {
    id: 'Pricing.experimentTooltipCopy.DatabaseResponseViewTooltipDescription',
    defaultMessage: 'View and manage all of your responses in one table.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.DatabaseResponseViewTooltipDescription',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_dashboard_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.DashboardTooltipHeading',
    defaultMessage: 'Dashboard',
    desc: {
      id: 'Pricing.experimentTooltipCopy.DashboardTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_dashboard_tooltip: {
    id: 'Pricing.experimentTooltipCopy.DashboardTooltip',
    defaultMessage:
      'Tell stories with your data by arranging charts, images, and findings in a custom layout. Share your dashboard with anyone.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.DashboardTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_dashboard_pwd_protection_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.DashboardPwdProtectionTooltipHeading',
    defaultMessage: 'Dashboard: Password protection',
    desc: {
      id: 'Pricing.experimentTooltipCopy.DashboardPwdProtectionTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_dashboard_pwd_protection_tooltip: {
    id: 'Pricing.experimentTooltipCopy.DashboardPwdProtectionTooltip',
    defaultMessage: 'Set a password for your dashboards for share more securely.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.DashboardPwdProtectionTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_word_cloud_combine_hide_tooltip_heading: {
    id: 'Pricing.experimentTooltipCopy.WordCloudCombineHideTooltipHeading',
    defaultMessage: 'Word clouds: Combine or hide words',
    desc: {
      id: 'Pricing.experimentTooltipCopy.WordCloudCombineHideTooltipHeading',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_word_cloud_combine_hide_tooltip: {
    id: 'Pricing.experimentTooltipCopy.WordCloudCombineHideTooltip',
    defaultMessage:
      'Get more control over the words that appear in your word cloud. Combine similar words, hide others, and choose the frequency of words to include.',
    desc: {
      id: 'Pricing.experimentTooltipCopy.WordCloudCombineHideTooltip',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
};

export default experimentTooltipCopy;
